import { IconType } from "@jsq/ds/icons";
import { DocumentRefreshStatusEnum } from "~/graphql/supergraphEnums";

export type MenuAction = {
  label: string;
  onSelect: () => void;
  iconType?: IconType;
};

export const MENU_ACTION_KEYS = {
  VIEW_CASE: "View case",
  SEND_DOCUMENT_UPDATE_REQUEST: "Send document update request",
  RESEND_DOCUMENT_UPDATE_REQUEST: "Resend document update request",
  CANCEL_DOCUMENT_UPDATE_REQUEST: "Cancel document update request",
  CREATE_CASE: "Create new case",
} as const;

const VIEW_CASE_ACTION: Omit<MenuAction, "onSelect"> = {
  label: MENU_ACTION_KEYS.VIEW_CASE,
  iconType: "external-link",
};

export const MENU_OPTIONS_BY_STATUS: Record<string, Omit<MenuAction, "onSelect">[]> = {
  [DocumentRefreshStatusEnum.Expired]: [
    { label: MENU_ACTION_KEYS.SEND_DOCUMENT_UPDATE_REQUEST },
    { label: MENU_ACTION_KEYS.CREATE_CASE },
  ],
  [DocumentRefreshStatusEnum.ExpiringSoon]: [
    { label: MENU_ACTION_KEYS.SEND_DOCUMENT_UPDATE_REQUEST },
    { label: MENU_ACTION_KEYS.CREATE_CASE },
  ],
  [DocumentRefreshStatusEnum.RequestSent]: [
    { label: MENU_ACTION_KEYS.RESEND_DOCUMENT_UPDATE_REQUEST },
    { label: MENU_ACTION_KEYS.CANCEL_DOCUMENT_UPDATE_REQUEST },
    VIEW_CASE_ACTION,
  ],
  [DocumentRefreshStatusEnum.RequestSentOverdue]: [
    { label: MENU_ACTION_KEYS.RESEND_DOCUMENT_UPDATE_REQUEST },
    { label: MENU_ACTION_KEYS.CANCEL_DOCUMENT_UPDATE_REQUEST },
    VIEW_CASE_ACTION,
  ],
};
